import styled from 'styled-components'

const InfoNavbarStyle = styled.div`
	--inImageMarginBottom: var(--sp5x);
	--inTitleMarginBottom: var(--sp3x);
	--inRegionMarginBottom: var(--sp4x);
	--inBtnMarginTop: var(--sp8x);

	height: 100%;
	padding: 0 !important;
	padding-top: calc(var(--infoContPadding) * 2.5) !important;
	-ms-overflow-style: none;
	scrollbar-width: none;

	&::-webkit-scrollbar {
		display: none;
	}

	.in-info-container {
		display: flex;
		flex-direction: column;
		padding: var(--infoContPadding);
		padding-top: calc(0.5 * var(--infoContPadding));
		overflow-y: scroll;
		-ms-overflow-style: none;
		scrollbar-width: none;

		.imageCont {
			--imagePaddingTop: 52.285%;

			margin-bottom: var(--inImageMarginBottom);
			border-radius: var(--sp2x);
			overflow: hidden;
		}

		.in-title {
			margin-bottom: var(--inTitleMarginBottom);
		}

		.in-region {
			margin-bottom: var(--inRegionMarginBottom);
		}

		.in-btn {
			margin-top: var(--inBtnMarginTop);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--inImageMarginBottom: var(--sp4x);
		--inTitleMarginBottom: var(--sp2x);
		--inRegionMarginBottom: var(--sp3x);
		--inBtnMarginTop: var(--sp7x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--inImageMarginBottom: var(--sp4x);
		--inTitleMarginBottom: var(--sp2x);
		--inRegionMarginBottom: var(--sp3x);
		--inBtnMarginTop: var(--sp6x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--inImageMarginBottom: var(--sp4x);
		--inTitleMarginBottom: var(--sp2x);
		--inRegionMarginBottom: var(--sp3x);
		--inBtnMarginTop: var(--sp6x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--inImageMarginBottom: var(--sp4x);
		--inTitleMarginBottom: var(--sp2x);
		--inRegionMarginBottom: var(--sp2-5x);
		--inBtnMarginTop: var(--sp5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--inImageMarginBottom: var(--sp4x);
		--inTitleMarginBottom: var(--sp2x);
		--inRegionMarginBottom: var(--sp2-5x);
		--inBtnMarginTop: var(--sp5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--inImageMarginBottom: var(--sp4x);
		--inTitleMarginBottom: var(--sp2x);
		--inRegionMarginBottom: var(--sp2-5x);
		--inBtnMarginTop: var(--sp5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.MobileSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeSMin}) {
		--inImageMarginBottom: var(--sp3x);
		--inTitleMarginBottom: var(--sp2x);
		--inRegionMarginBottom: var(--sp2-5x);
		--inBtnMarginTop: var(--sp5x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.MobileSizeMin}) {
		--inImageMarginBottom: var(--sp3x);
		--inTitleMarginBottom: var(--sp2x);
		--inRegionMarginBottom: var(--sp2-5x);
		--inBtnMarginTop: var(--sp5x);
	}
`

export default InfoNavbarStyle
